
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCustomerSurveyDtDialog extends Serenity.Extensions.GridEditorDialog<PsCustomerSurveyDtRow> {
        protected getFormKey() { return PsCustomerSurveyDtForm.formKey; }
        // protected getIdProperty() { return PsCustomerSurveyDtRow.idProperty; }
        protected getLocalTextPrefix() { return PsCustomerSurveyDtRow.localTextPrefix; }
        protected getNameProperty() { return PsCustomerSurveyDtRow.nameProperty; }
        // protected getService() { return PsCustomerSurveyDtService.baseUrl; }
        // protected getDeletePermission() { return PsCustomerSurveyDtRow.deletePermission; }
        // protected getInsertPermission() { return PsCustomerSurveyDtRow.insertPermission; }
        // protected getUpdatePermission() { return PsCustomerSurveyDtRow.updatePermission; }

        protected form = new PsCustomerSurveyDtForm(this.idPrefix);
        private  user: string ;
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            
            if (this.isEditMode) {
                // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSaveApproveBtn: Serenity.ToolButton =
                {
                    title: "Active",
                    hint: "Active [alt+s]",
                    separator: false,
                    cssClass: "button-save-approve",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        
                        Q.confirm(
                           '  ยืนยันการเปิดแสดง',
                            () => {
                                this.form.Status.value = "1";
                            //     this.form.ActiveBy.value = this.user;
                            // this.form.Activedate.value = (new Date(Date.now())).toDateString();
                                this.form.Status.forceUpdate();
                                this.save((response) => {
                                    this.dialogClose();
                                });
                            });
                    }
                };
                buttons.push(newSaveApproveBtn);
                let newSaveRejectedBtn: Serenity.ToolButton =
            {
                title: "InActive",
                hint: "ยกเลิก Active",
                separator: false,
                cssClass: "button-save-cancle",
                icon: "fa fa-times-circle text-red",
                
                onClick: (e) => {
                    Q.confirm(
                        "ยกเลิกการเปิดแสดงนี้ "
                        ,
                        () => {
                            this.form.Status.value = "0";
                            // this.form.ActiveBy.value = this.user;
                            // this.form.Activedate.value = (new Date(Date.now())).toDateString();
                            this.form.Status.forceUpdate();
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                }
            }
            buttons.push(newSaveRejectedBtn);
            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
            // console.log('User Id : ' + userId.ShopId);
            this.user = userId.Username;

            
           
                if (this.entity.Status == 1) {
                    this.toolbar.findButton('button-save-approve').hide();
                    // this.toolbar.findButton('button-save-cancle').hide();
                    // this.toolbar.findButton('button-save-reject').hide();
                } else {
                    // this.toolbar.findButton('button-save-approve').hide();
                    this.toolbar.findButton('button-save-cancle').hide();

                }
            
        }

    }
}